import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-black border-t border-cyan-500/10 py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <div className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_layout-kit-1/artifacts/fbm0hm7y_Represenx_logo_trans.png" 
              alt="RepresenX" 
              className="h-8 w-auto opacity-80"
            />
            <span className="text-gray-400 text-sm">{t('footer.copyright')}</span>
          </div>
          
          <div className="flex items-center space-x-6">
            <Link to="/ethics" className="text-gray-400 hover:text-cyan-400 text-sm transition-colors duration-200">
              {t('footer.ethicsGovernance')}
            </Link>
            <Link to="/privacy" className="text-gray-400 hover:text-cyan-400 text-sm transition-colors duration-200">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms" className="text-gray-400 hover:text-cyan-400 text-sm transition-colors duration-200">
              {t('footer.terms')}
            </Link>
            <Link to="/contact" className="text-gray-400 hover:text-cyan-400 text-sm transition-colors duration-200">
              {t('footer.contact')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
